import { render, staticRenderFns } from "./HistoricalImages.vue?vue&type=template&id=7bfcf05f&scoped=true&"
import script from "./HistoricalImages.vue?vue&type=script&lang=js&"
export * from "./HistoricalImages.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalImages.vue?vue&type=style&index=0&id=7bfcf05f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfcf05f",
  null
  
)

export default component.exports